
import styled from "styled-components"
import InputSelect from "../../components/shared/input/new/InputSelect"
import { useState } from "react"
import { locationDat10CitySpecific } from "../../utils/locationData/locationOptions"
import nakliyeFiyatHesaplamaAracOptions from "../../utils/yukOptions/nakliyeFiyatHesaplamaAracOptions"
import NakliyeIndex4AllPricesAracTypeInput from "../../components/shared/input/nakliyeIndex/NakliyeIndex4AllPricesAracTypeInput"
import NakliyeIndex4AllPricesNeredenInput from "../../components/shared/input/nakliyeIndex/NakliyeIndex4AllPricesNeredenInput"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { getNakliyeHesaplamaIndex4AllResult } from "../../features/nakliyeIndex/nakliyeIndexSlice"
import { useSelector } from "react-redux"
import formatConverter from "../../helper/formatConverter"
import {BiSolidSortAlt, BiSolidUpArrow, BiSolidDownArrow} from "react-icons/bi"
import aracTonajOptions, { aracTonajOptionsShort } from "../../utils/yukOptions/nakliyeFiyatHesaplamaTonajOptions"
import SmallSpinner from "../../components/shared/spinners/SmallSpinner"

const Container = styled.div`
    width: 100%;

    .wrapper{
        display: flex;
        flex-direction: column;
        width: 100%;
        color: ${({theme}) => theme.mainTextColor};

        .content{
            display: flex;
            flex-direction: column;
            margin: 0 !important;

            .top-container{
                display: flex;
                justify-content: space-between;

                .filter-container{
                    display: flex;
                    gap: 20px;
                }

                .btn-container{
                    display: flex;
                }
            }

            .main-content{
                width: 100%;
                margin-bottom: 80px;

                table{
                    width: 100%;
                    border-collapse: collapse;

                    thead{
                        width: 100%;
                        background-color: var(--color-main);

                        tr{

                            th{
                                color: #fff;
                                padding: 10px 15px;
                                border-right: 1px solid #fff;
                                font-size: var(--font-size-sm);
                                font-weight: var(--font-weight-lg);

                                &:nth-child(1), &:nth-child(2){
                                    text-align: start;
                                    border-left: 1px solid var(--color-main);
                                }
                                
                                &:last-child{
                                    border-right: 1px solid var(--color-main);
                                }

                                .title-text{
                                    width: 100%;
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;

                                    .sort-icon{
                                        font-size: 1rem;
                                        cursor: pointer;
                                    }
                                }

                            }
                        }
                    }

                    tbody{

                        tr{
                            td{

                                border: 1px solid ${({theme}) => theme.mainTextColor};
                                text-align: center;
                                font-size: var(--font-size-sm);
                                font-weight: var(--font-weight-lg);

                                &:nth-child(1), &:nth-child(2){
                                    /* background-color: ${({theme}) => theme.secondaryBgColor}; */
                                    padding: 8px 15px;
                                    text-align: start;
                                }

                                &:last-child{
                                    width: 250px !important;
                                }

                                input{
                                    width: 100%;
                                    text-align: center;
                                    padding: 8px 0;

                                }
                            }
                        }

                    }
                }
            }

        }
    }
`

const initialTitles = [
    {
        id: 1,
        text: "Nereden",
        sortState: 0
    },
    {
        id: 2,
        text: "Nereye",
        sortState: 0
    },
    {
        id: 3,
        text: "Km",
        sortState: 0
    },
    {
        id: 4,
        text: "Maliyet",
        sortState: 0
    },
    {
        id: 5,
        text: "İndex-4",
        sortState: 0
    },
    {
        id: 6,
        text: "Nakliye Fiyatı (Normal Gider)",
        sortState: 0
    },
    {
        id: 7,
        text: "Karlılık(%)",
        sortState: 0
    },
]


const NakliyeIndex4Result = () => {

    const [aracType, setAracType] = useState({
        id: 4,
        text: "Tır",
        value:"Tır",
    })
    const [nereden, setNereden] = useState({
        "cityId": "35",
        "city": "İzmir",
        "location": "İzmir",
        "lat": "38.46206321557190",
        "lng": "27.22654626255810",
        "region": "Ege"
    })

    const [tonajData, setTonajData] = useState({
        value: 27,
        text: "27 Ton",
    })

    const [tonajOptions, setTonajOptions] = useState([])

    const {nakliyeHesaplamaIndex4AllResult, isLoadingGetNakliyeHesaplamaIndex4AllResult} = useSelector(state => state.nakliyeIndex)
    const [titles, setTitles] = useState(initialTitles)

    const dispatch = useDispatch()



    useEffect(() => {
        dispatch(getNakliyeHesaplamaIndex4AllResult({
            nerden: nereden?.cityId,
            aracTuru: aracType?.id,
            tonaj: tonajData.value,
            nereyeOrder: titles[1].sortState === 0 ? "equal" : titles[1].sortState === 1 ? "asc" : "desc", 
            kmOrder: titles[2].sortState === 0 ? "equal" : titles[1].sortState === 1 ? "asc" : "desc",
            maliyetOrder: titles[3].sortState === 0 ? "equal" : titles[1].sortState === 1 ? "asc" : "desc",
            indexOrder: titles[4].sortState === 0 ? "equal" : titles[1].sortState === 1 ? "asc" : "desc",
            nakliyeFiyatOrder: titles[5].sortState === 0 ? "equal" : titles[1].sortState === 1 ? "asc" : "desc",
            karlilik: titles[6].sortState === 0 ? "equal" : titles[1].sortState === 1 ? "asc" : "desc"
        }))
    },[nereden, aracType, titles, tonajData])

    useEffect(() => {
        if(aracType?.id){
          const list= aracTonajOptionsShort.find(item => item.aracTypeId === aracType?.id).tonajOptions
          setTonajOptions(list)
          setTonajData(list[list.length-1])
        } 
      },[aracType?.id])

    const handleSortChange = ({id, sortState}) => {
        const updatedList = titles.map((item) => {
            if(item.id === id){
                return {...item, sortState}
            }
            else{
                return {...item, sortState: 0}
            }
        })
        setTitles(updatedList)
    }


  return (
    <Container>
    <div className="wrapper">
        <div className="content">
            <div className="top-container">
                <div className="filter-container">
                    <NakliyeIndex4AllPricesAracTypeInput data={aracType} setData={setAracType} labelText={"Araç Türü"} initialOptions={nakliyeFiyatHesaplamaAracOptions} inputWidth={"280px"} name={"nakliyeFiyatHesaplamaAracOptions"}/>
                    <NakliyeIndex4AllPricesNeredenInput data={nereden} setData={setNereden} labelText={"Nereden"} initialOptions={locationDat10CitySpecific} inputWidth={"280px"} name={"index4KaynakVeriAracType"}/>
                    <InputSelect data={tonajData.text} setData={setTonajData} labelText={"Tonaj"} inputWidth={"280px"} initialOptions={tonajOptions} name={"tonajData"}/>
                </div>
                <div className="btn-container">
                    {/* <Btn borderColor="#E85446" color="#E85446" width={"200px"} handleClick={() => dispatch(getTopluNakliyeUpdateCityToTownIndexExcel())} isDisabled={isLoadingGetTopluNakliyeUpdateCityToTownIndexExcel} cursor={isLoadingGetTopluNakliyeUpdateCityToTownIndexExcel && "not-allowed"}>{isLoadingGetTopluNakliyeUpdateCityToTownIndexExcel ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Excel Çıktı Al"}</Btn> */}
                </div>
            </div>

            <div className="main-content">
                    <table>
                        <thead>
                            <tr>
                                {
                                    titles.map((item, i) => (
                                        <th key={item.id}>
                                            <div className={"title-text"}>
                                                {item.text}
                                                {
                                                    (item.sortState === 0 && i !== 0) &&
                                                    <BiSolidSortAlt onClick={() => handleSortChange({id: item.id, sortState: item.sortState === 2 ? 0 : item.sortState+1})} className="sort-icon"/>
                                                }
                                                {
                                                    (item.sortState === 1 && i !== 0) &&
                                                    <BiSolidUpArrow onClick={() => handleSortChange({id: item.id, sortState: item.sortState === 2 ? 0 : item.sortState+1})} className="sort-icon"/>
                                                }
                                                {
                                                    (item.sortState === 2 && i !== 0) &&
                                                    <BiSolidDownArrow onClick={() => handleSortChange({id: item.id, sortState: item.sortState === 2 ? 0 : item.sortState+1})} className="sort-icon"/>
                                                }   
                                            </div>
                                        </th>
                                    ))
                                }
                            </tr>
                        </thead>
                        <tbody>
                                {
                                    nakliyeHesaplamaIndex4AllResult.map(item => (
                                        <tr>
                                            <td>{isLoadingGetNakliyeHesaplamaIndex4AllResult ? <SmallSpinner size={"16px"} bgColor={"#E85446"} color={"#fff"}/> : item.nereden}</td>
                                            <td>{isLoadingGetNakliyeHesaplamaIndex4AllResult ? <SmallSpinner size={"16px"} bgColor={"#E85446"} color={"#fff"}/> : item.nereye}</td>
                                            <td>{isLoadingGetNakliyeHesaplamaIndex4AllResult ? <SmallSpinner size={"16px"} bgColor={"#E85446"} color={"#fff"}/> : `${formatConverter(item.km, 0)} Km`}</td>
                                            <td>{isLoadingGetNakliyeHesaplamaIndex4AllResult ? <SmallSpinner size={"16px"} bgColor={"#E85446"} color={"#fff"}/> : `${formatConverter(item.maliyet, 0)} TL`}</td>
                                            <td>{isLoadingGetNakliyeHesaplamaIndex4AllResult ? <SmallSpinner size={"16px"} bgColor={"#E85446"} color={"#fff"}/> : `${formatConverter(item.index, 0)}`}</td>
                                            <td>{isLoadingGetNakliyeHesaplamaIndex4AllResult ? <SmallSpinner size={"16px"} bgColor={"#E85446"} color={"#fff"}/> : `${formatConverter(item.nakliyeFiyati, 0)} TL`}</td>
                                            <td>{isLoadingGetNakliyeHesaplamaIndex4AllResult ? <SmallSpinner size={"16px"} bgColor={"#E85446"} color={"#fff"}/> : `${formatConverter(item.karlilik, 0)}`}</td>
                                        </tr>
                                    ))
                                }
                        </tbody>
                    </table>

            </div>
        </div>
    </div>
</Container>
  )
}

export default NakliyeIndex4Result